<div class="panel panel-flat">
  <div class="content-group">
    <div class="page-header page-header-default">
      <div class="page-header-content">
        <div class="page-title">
          <h5>
            <i class="icon-stack position-left"></i>
            <span class="text-semibold">Awards</span>
          </h5>
        </div>

        <div class="heading-elements">
          <div class="btn-group pull-right">
            <a [routerLink]="['/awardadd']" type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
              <i class="icon-add position-left"></i> Add Award</a>
            <a type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
              <i class="icon-printer position-left"></i>Print</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="padding-left:30px;">
      <div class="col-md-2 form-group required">
        <span style="float:left" class="control-label">Filter by: Status</span>
        <select name="status" required [(ngModel)]="filter" (ngModelChange)="getAwardFilter(filter)"
          class="form-control">
          <option selected disabled>Status</option>
          <option value="">All</option>
          <option value="&status=pending">Pending</option>
          <option value="&status=scheduled">Scheduled</option>
          <option value="&status=drawed">Drawed</option>
          <option value="&status=sold">Sold</option>
          <option value="&status=received">Received</option>
          <option value="&status=initialized">Initialized</option>
        </select>
      </div>

      <div class="col-md-3 form-group required">
        <span class="control-label">&nbsp; </span>
      </div>
    </div>

    <div class="panel-body">
      <table class="table datatable-column-search-inputs">
        <thead>
          <tr>
            <th>Equb</th>
            <th>Winner</th>
            <th>Code</th>
            <th>Amount</th>
            <th>Draw Date</th>
            <th>Recieve Date</th>
            <th>Guarantee Type</th>
            <th>Guarantee Ref.</th>
            <th>Status</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let award of awards | paginate: { id: 'awards',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
            <td><a [routerLink]="['/award',award.id]"> {{award?.ekub?.data.ekub_id}}</a></td>
            <td>{{award?.winner?.data.username | titlecase }}</td>
            <td>{{award?.code}}</td>
            <td>{{award?.amount|number:'1.2-2'}} ETB</td>
            <td>{{award?.draw_date| date: 'MMM d, y, h:mm:ss a'}}</td>
            <td><span *ngIf="award?.recieved_date">{{award?.recieved_date|date:short}}</span><span
                *ngIf="award?.recieved_date">-</span></td>
            <td><span *ngIf="award?.guarantee_type">{{award?.guarantee_type}}</span><span
                *ngIf="award?.guarantee_type">-</span></td>
            <td><span *ngIf="award?.guarantee_ref_number">{{award?.guarantee_ref_number}}</span><span
                *ngIf="award?.guarantee_ref_number">-</span></td>
            <td>
              <span class="label label-block label-success"
                *ngIf="award.status === 'Scheduled' || award.status === 'scheduled'">{{award.status}}</span>
              <span class="label label-block label-default"
                *ngIf="award.status === 'Pending' || award.status === 'pending'">{{award.status}}</span>
              <span class="label label-block bg-royal-400"
                *ngIf="award.status === 'Initialized' || award.status === 'initialized'">{{award.status}}</span>
              <span class="label label-block label-primary"
                *ngIf="award.status === 'Drawed' || award.status === 'drawed'">{{award.status}}</span>
              <span class="label label-block bg-royal-400"
                *ngIf="award.status === 'Received' || award.status === 'received'">{{award.status}}</span>
              <span class="label label-block bg-teal"
                *ngIf="award.status === 'sold' || award.status === 'sold'">{{award.status}}</span>
            </td>
            <td class="text-center">
              <ul class="icons-list">
                <li class="dropdown">
                  <a href="" class="dropdown-toggle" data-toggle="dropdown">
                    <i class="icon-menu9"></i>
                  </a>

                  <ul class="dropdown-menu dropdown-menu-right">
                    <li>
                      <a href="" [routerLink]="['/awardadd']"
                        [queryParams]="{'id':award.id, 'ekub':award.ekub.data.id}">
                        <i class="icon-file-pdf"></i>Update</a>
                    </li>
                    <li>
                      <a href="">
                        <i class="icon-file-excel"></i>Delete</a>
                    </li>
                    <li class="dropdown-submenu dropdown-submenu-left">
                      <a href="javascript:void(0);">Change Status</a>
                      <ul class="dropdown-menu">
                        <li>
                          <a (click)="changeStatus(award,'pending')">
                            <i class="icon-shuffle"></i> Pending</a>
                        </li>
                        <li>
                          <a (click)="changeStatus(award,'drawed')">
                            <i class="icon-shuffle"></i> Drawed</a>
                        </li>
                        <li>
                          <a (click)="changeStatus(award,'scheduled')">
                            <i class="icon-shuffle"></i> Scheduled</a>
                        </li>
                        <li>
                          <a (click)="changeStatus(award,'received')">
                            <i class="icon-shuffle"></i> Received</a>
                        </li>
                        <li>
                          <a (click)="changeStatus(award,'sold')">
                            <i class="icon-shuffle"></i> Sold</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </td>
          </tr>
          <tr *ngIf="awards?.length <=0">
            <td colspan="10" class="text-center"> <i class="icon-info22">&nbsp;</i>No Awards given yet!</td>
          </tr>
        </tbody>
      </table>

      <br>

      <div class="row">
        <!-- <p class="text-left" style="color:#00695C;font-weight:600;padding:10px;">{{val}}</p> -->
        <div class="text-center">

          <pagination-controls id="awards" (pageChange)="pageChanged(currentPage = $event)">
          </pagination-controls>

          <br>
        </div>

      </div>


    </div>
  </div>
</div>